module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_G170207.e04e291e.png";